export default function ToolbarSelect({ label, value, options, onChange, placeholder }) {
    return (
        <label className="toolbar-select">
            <span className="toolbar-select-label">{label}</span>
            <select value={value ?? ""} onChange={(e) => onChange(Number(e.target.value))}>
                <option value="" disabled>
                    {placeholder || "—"}
                </option>
                {options.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select>
        </label>
    );
}
